//TODO: remove dependancy on locale files. store json somewhere else, since it is the same in each locale file and is error prone.

const shopLocations = ['us', 'gb', 'de', 'at', 'fr', 'es', 'ca', 'it', 'nl', 'au', 'nz', 'eu', 'cn', 'hk', 'tw', 'kr', 'jp'];

const euCountries = ['be', 'bg', 'cz', 'dk', 'de', 'ee', 'ie', 'gr', 'es', 'fr', 'hr', 'it', 'cy', 'lv', 'lt', 'lu', 'hu', 'mt', 'nl', 'at', 'pl', 'pt', 'ro', 'si', 'sk', 'fi', 'se', 'gb'];

// const latamCountries = ['ar', 'co', 'pe', 'mx', 'cl', 'hn', 'do', 'cr', 'gt', 'pa'];

const apacCountries = ['cn', 'hk', 'tw', 'kr', 'jp'];

theme.geoip = {
  init: function() {

    //bind to click event of country selector
    var countrySelectors = [].slice.call(document.querySelectorAll('.other-sites .site-nav__submenu .site-nav__link'));
    countrySelectors.forEach(function(countrySelector) {
      var country = countrySelector.querySelector('span').innerText;
      countrySelector.onclick = function() {
        theme.geoip.setCookie(country.toLowerCase());
      }
    });

    //bind to clicks of international site links on the popup
    var siteSelectors = [].slice.call(document.querySelectorAll('.international-site-list li'));
    siteSelectors.forEach(function(siteSelector) {
      var country = siteSelector.id;
      var link = siteSelector.querySelector('a');
      link.onclick = function() {
        theme.geoip.setCookie(country.toLowerCase());
      }
    });

    theme.geoip.checkCountry();
  },
  checkCountry: function() {
    var currentLocale = theme.geoip.getCookie();
    geoip2.country(
      function(location) {
        var countryByIp = location.country.iso_code.toLowerCase();
        var currentSite = theme.geoip.getCurrentSite();

        if (currentLocale) {
          theme.geoip.routeSite(currentSite, currentLocale, countryByIp);
        } else  {
          theme.geoip.routeSite(currentSite, "", countryByIp);
        }
      },
      function(error) {
        //error handling goes here
      }
    );
  },
  checkUrl: function(url) {
    var request = new XMLHttpRequest;
    request.open('GET', url, true);
    request.send();
    request.onreadystatechange = function(){
        if(request.status==200){
            // (request.readyState);
            return true;
        }else{
            return false;
        }
    }
  },
  routeSite: function(currentSite, currentLocale, countryByIp) {
    

    window.theme.usersCountry = countryByIp;

    //Make sure that if 'at' comes through we set it to 'de' for Germany
    currentLocale = currentLocale.replace( /at/gi, 'de' );
    currentSite = currentSite.replace( /at/gi, 'de' );

    //Check if they are already on the correct site
    if ( currentLocale.toLowerCase() === currentSite.toLowerCase() || countryByIp.toLowerCase() === currentSite.toLowerCase() ) {
      return;
    }

    if ( euCountries.includes(countryByIp) && !shopLocations.includes(countryByIp) ) {
      countryByIp = "eu";
    }

    if ( !shopLocations.includes(countryByIp) ) {
      return;
    }

    //display the international popup, and show the correct country and site name
    var modalElement = document.querySelector('#international-modal');
    modalElement.setAttribute('data-show-modal', 'true');
    document.body.style.overflow = "hidden";

    //Set the text for the various strings in the modal
    var welcomeElement = document.querySelector('#international-welcome');
    welcomeElement.innerText = theme.geoip.getWelcomeString(countryByIp);

    var attentionElement = document.querySelector('#attention');
    attentionElement.innerText = theme.geoip.getAttentionString(countryByIp);

    var noticedMessageElement = document.querySelector('#noticed-message');
    noticedMessageElement.innerText = theme.geoip.getNoticedString(countryByIp);

    var enterSiteElement = document.querySelector('#enter-site');
    enterSiteElement.innerText = theme.geoip.getEnterString(countryByIp);

    var siteLinks = {
      "us": "//www.roccat.com",
      "eu": "//eu.roccat.com",
      "gb": "//uk.roccat.com",
      "uk": "//uk.roccat.com",
      "de": "//de.roccat.com",
      "fr": "//fr.roccat.com",
      "au": "//au.roccat.com",
      "cn": "//cn.roccat.com",
      "hk": "//hk.roccat.com",
      "tw": "//tw.roccat.com",
      "kr": "//kr.roccat.com",
      "jp": "//jp.roccat.com",
      "ca": "//ca.roccat.com",
    }

    if (typeof window.geoUrlMap !== undefined) {
      var siteLinks = {
        "us": geoUrlMap.us,
        "eu": geoUrlMap.eu,
        "gb": geoUrlMap.uk,
        "uk": geoUrlMap.uk,
        "de": geoUrlMap.de,
        "fr": geoUrlMap.fr,
        "au": geoUrlMap.au,
        "cn": geoUrlMap.cn,
        "hk": geoUrlMap.hk,
        "tw": geoUrlMap.tw,
        "kr": geoUrlMap.kr,
        "jp": geoUrlMap.jp,
        "ca": geoUrlMap.ca,
      }
    } else {
      var siteLinks = {
        "us": "//www.roccat.com",
        "eu": "//eu.roccat.com",
        "gb": "//uk.roccat.com",
        "uk": "//uk.roccat.com",
        "de": "//de.roccat.com",
        "fr": "//fr.roccat.com",
        "au": "//au.roccat.com",
        "cn": "//cn.roccat.com",
        "hk": "//hk.roccat.com",
        "tw": "//tw.roccat.com",
        "kr": "//kr.roccat.com",
        "jp": "//jp.roccat.com",
        "ca": "//ca.roccat.com",
      }
    }

    var enterLink = document.querySelector('#international-modal .btn--primary');

    enterLink.setAttribute("href", siteLinks[countryByIp]);

    var continueElement = document.querySelector('#continue-link');
    continueElement.innerText = theme.geoip.getContinueString(currentSite);

    continueElement.onclick = function(e) {
      e.preventDefault();
      theme.geoip.setCookie(currentSite);
      modalElement.setAttribute('data-show-modal', 'false');
      document.body.style.overflow = "auto";
    };

    //Set the text for each country button
    var countryButtonTextArry = theme.geoip.getCountryButtonsString(countryByIp);
    Object.keys(countryButtonTextArry).forEach(function(i){
      var countryButton = document.querySelector('.international-site-list #' + i + ' span');
      countryButton.innerText = countryButtonTextArry[i];
    });

    //hide the customer location and current site from the other options
    var currentSiteLink = document.querySelector('.international-site-list #' + countryByIp);
    var currentLocaleLink = document.querySelector('.international-site-list #' +currentSite)
    currentSiteLink.style.display = "none";
    currentLocaleLink.style.display = "none";
  },
  cleanJSONFromServer: function(jsonObject) {
    var jsonCleaned = jsonObject.replace(/&quot;/g,'"').replace(/=&gt;/g,':'); //Prepare for JSON parse
    return JSON.parse(jsonCleaned);
  },
  getWelcomeString: function(ipCountry) {
    // Get text data for a welcome
    var welcomeObject = theme.geoip.cleanJSONFromServer("{&quot;us&quot; =&gt; &quot;Welcome to ROCCAT!&quot;, &quot;eu&quot; =&gt; &quot;Welcome to ROCCAT!&quot;, &quot;fr&quot; =&gt; &quot;BIENVENUE SUR LE SITE DE ROCCAT!&quot;, &quot;gb&quot; =&gt; &quot;Welcome to ROCCAT!&quot;, &quot;de&quot; =&gt; &quot;WILLKOMMEN BEI ROCCAT!&quot;, &quot;au&quot; =&gt; &quot;Welcome to ROCCAT!&quot;, &quot;cn&quot; =&gt; &quot;欢迎来到ROCCAT!&quot;, &quot;hk&quot; =&gt; &quot;歡迎來到 ROCCAT!&quot;, &quot;tw&quot; =&gt; &quot;歡迎來到 ROCCAT!&quot;, &quot;kr&quot; =&gt; &quot;ROCCAT에 오신 것을 환영합니다!&quot;, &quot;jp&quot; =&gt; &quot;ROCCAT へようこそ!&quot;, &quot;ca&quot; =&gt; &quot;Welcome to ROCCAT!&quot;}");
    return welcomeObject[ ipCountry ] || welcomeObject[ "us" ];
  },
  getAttentionString: function(ipCountry) {
    // Get text data for attention
    var attentionObject = theme.geoip.cleanJSONFromServer("{&quot;us&quot; =&gt; &quot;ATTENTION&quot;, &quot;eu&quot; =&gt; &quot;ATTENTION&quot;, &quot;fr&quot; =&gt; &quot;Attention&quot;, &quot;gb&quot; =&gt; &quot;ATTENTION&quot;, &quot;de&quot; =&gt; &quot;Achtung&quot;, &quot;au&quot; =&gt; &quot;ATTENTION&quot;, &quot;cn&quot; =&gt; &quot;注意&quot;, &quot;hk&quot; =&gt; &quot;注意&quot;, &quot;tw&quot; =&gt; &quot;注意&quot;, &quot;kr&quot; =&gt; &quot;주의&quot;, &quot;jp&quot; =&gt; &quot;注意&quot;, &quot;ca&quot; =&gt; &quot;ATTENTION&quot;}");
    return attentionObject[ ipCountry ] || attentionObject[ "us" ];
  },
  getNoticedString: function(ipCountry) {
    // Get text data for a welcome
    var noticedObject = theme.geoip.cleanJSONFromServer("{&quot;us&quot; =&gt; &quot;We noticed you are located in the United States&quot;, &quot;eu&quot; =&gt; &quot;We noticed you are located in the European Union&quot;, &quot;fr&quot; =&gt; &quot;Votre position actuelle : France&quot;, &quot;gb&quot; =&gt; &quot;We noticed you are located in the United Kingdom&quot;, &quot;de&quot; =&gt; &quot;Wie wir sehen, befindest du dich hier: Deutschland&quot;, &quot;au&quot; =&gt; &quot;We noticed you are located in Australia&quot;, &quot;cn&quot; =&gt; &quot;我们发现您位于中国&quot;, &quot;hk&quot; =&gt; &quot;我們發現您位於中國&quot;, &quot;tw&quot; =&gt; &quot;我們發現您位於台灣&quot;, &quot;kr&quot; =&gt; &quot;여러분의지역이우리나라인것으로확인됩니다&quot;, &quot;jp&quot; =&gt; &quot;お客様は日本にお住まいのようです。&quot;, &quot;ca&quot; =&gt; &quot;We noticed you are located in Canada&quot;}");
    return noticedObject[ ipCountry ] || noticedObject[ "us" ];
  },
  getEnterString: function(ipCountry) {
    var enterObject = theme.geoip.cleanJSONFromServer("{&quot;us&quot; =&gt; &quot;Enter the US Site&quot;, &quot;eu&quot; =&gt; &quot;Enter the EU Site&quot;, &quot;fr&quot; =&gt; &quot;ENTRER SUR LE SITE FRANÇAIS&quot;, &quot;de&quot; =&gt; &quot;DE-WEBSITE BESUCHEN&quot;, &quot;gb&quot; =&gt; &quot;Enter the UK Site&quot;, &quot;au&quot; =&gt; &quot;Enter the AU Site&quot;, &quot;cn&quot; =&gt; &quot;请进入中国网站&quot;, &quot;hk&quot; =&gt; &quot;請進入中國網站&quot;, &quot;tw&quot; =&gt; &quot;請進入台灣網站&quot;, &quot;kr&quot; =&gt; &quot;우리나라장소를입력하세요&quot;, &quot;jp&quot; =&gt; &quot;日本サイトにアクセス&quot;, &quot;ca&quot; =&gt; &quot;Enter the CA Site&quot;}");
    return enterObject[ ipCountry ] || enterObject[ "us" ];
  },
  getContinueString: function(ipCountry) {
    // Get text data for a welcome
    var continueObject = theme.geoip.cleanJSONFromServer("{&quot;us&quot; =&gt; &quot;Continue with the US Site&quot;, &quot;eu&quot; =&gt; &quot;Continue with the EU Site&quot;, &quot;fr&quot; =&gt; &quot;Continuer avec le site français&quot;, &quot;de&quot; =&gt; &quot;Auf der deutschen Seite fortfahren&quot;, &quot;gb&quot; =&gt; &quot;Continue with the UK Site&quot;, &quot;au&quot; =&gt; &quot;Continue with the Australian Site&quot;, &quot;cn&quot; =&gt; &quot;继续浏览简体中文网站&quot;, &quot;hk&quot; =&gt; &quot;繼續瀏覽繁體中文 (香港) 網站&quot;, &quot;tw&quot; =&gt; &quot;繼續瀏覽繁體中文網站&quot;, &quot;kr&quot; =&gt; &quot;한국 사이트로 계속하기&quot;, &quot;jp&quot; =&gt; &quot;日本語のウェブサイトで続ける&quot;, &quot;ca&quot; =&gt; &quot;Continue with the Canadian Site&quot;}");
    return continueObject[ ipCountry ] || continueObject[ "us" ];
  },
  getCountryButtonsString: function(ipCountry) {
    // Get text data for a welcome
    var countryButtonsObject = theme.geoip.cleanJSONFromServer("{&quot;us&quot; =&gt; {&quot;us&quot; =&gt; &quot;United States&quot;, &quot;eu&quot; =&gt; &quot;European Union&quot;, &quot;fr&quot; =&gt; &quot;France&quot;, &quot;gb&quot; =&gt; &quot;United Kingdom&quot;, &quot;de&quot; =&gt; &quot;Germany&quot;, &quot;au&quot; =&gt; &quot;Australia&quot;, &quot;cn&quot; =&gt; &quot;China&quot;, &quot;hk&quot; =&gt; &quot;Hong Kong&quot;, &quot;tw&quot; =&gt; &quot;Taiwan&quot;, &quot;kr&quot; =&gt; &quot;Korea&quot;, &quot;jp&quot; =&gt; &quot;Japan&quot;, &quot;ca&quot; =&gt; &quot;Canada&quot;}, &quot;gb&quot; =&gt; {&quot;us&quot; =&gt; &quot;United States&quot;, &quot;eu&quot; =&gt; &quot;European Union&quot;, &quot;fr&quot; =&gt; &quot;France&quot;, &quot;gb&quot; =&gt; &quot;United Kingdom&quot;, &quot;de&quot; =&gt; &quot;Germany&quot;, &quot;au&quot; =&gt; &quot;Australia&quot;, &quot;cn&quot; =&gt; &quot;China&quot;, &quot;hk&quot; =&gt; &quot;Hong Kong&quot;, &quot;tw&quot; =&gt; &quot;Taiwan&quot;, &quot;kr&quot; =&gt; &quot;Korea&quot;, &quot;jp&quot; =&gt; &quot;Japan&quot;, &quot;ca&quot; =&gt; &quot;Canada&quot;}, &quot;eu&quot; =&gt; {&quot;us&quot; =&gt; &quot;United States&quot;, &quot;eu&quot; =&gt; &quot;European Union&quot;, &quot;fr&quot; =&gt; &quot;France&quot;, &quot;gb&quot; =&gt; &quot;United Kingdom&quot;, &quot;de&quot; =&gt; &quot;Germany&quot;, &quot;au&quot; =&gt; &quot;Australia&quot;, &quot;cn&quot; =&gt; &quot;China&quot;, &quot;hk&quot; =&gt; &quot;Hong Kong&quot;, &quot;tw&quot; =&gt; &quot;Taiwan&quot;, &quot;kr&quot; =&gt; &quot;Korea&quot;, &quot;jp&quot; =&gt; &quot;Japan&quot;, &quot;ca&quot; =&gt; &quot;Canada&quot;}, &quot;fr&quot; =&gt; {&quot;us&quot; =&gt; &quot;États-Unis&quot;, &quot;eu&quot; =&gt; &quot;Union européenne&quot;, &quot;fr&quot; =&gt; &quot;France&quot;, &quot;gb&quot; =&gt; &quot;Royaume-Uni&quot;, &quot;de&quot; =&gt; &quot;Allemagne&quot;, &quot;au&quot; =&gt; &quot;Australie&quot;, &quot;cn&quot; =&gt; &quot;Chine&quot;, &quot;hk&quot; =&gt; &quot;Hong Kong&quot;, &quot;tw&quot; =&gt; &quot;Taïwan&quot;, &quot;kr&quot; =&gt; &quot;Corée&quot;, &quot;jp&quot; =&gt; &quot;Japon&quot;, &quot;ca&quot; =&gt; &quot;Canada&quot;}, &quot;uk&quot; =&gt; {&quot;us&quot; =&gt; &quot;United States&quot;, &quot;eu&quot; =&gt; &quot;European Union&quot;, &quot;fr&quot; =&gt; &quot;France&quot;, &quot;gb&quot; =&gt; &quot;United Kingdom&quot;, &quot;de&quot; =&gt; &quot;Germany&quot;, &quot;au&quot; =&gt; &quot;Australia&quot;, &quot;cn&quot; =&gt; &quot;China&quot;, &quot;hk&quot; =&gt; &quot;Hong Kong&quot;, &quot;tw&quot; =&gt; &quot;Taiwan&quot;, &quot;kr&quot; =&gt; &quot;Korea&quot;, &quot;jp&quot; =&gt; &quot;Japan&quot;, &quot;ca&quot; =&gt; &quot;Canada&quot;}, &quot;au&quot; =&gt; {&quot;us&quot; =&gt; &quot;United States&quot;, &quot;eu&quot; =&gt; &quot;European Union&quot;, &quot;fr&quot; =&gt; &quot;France&quot;, &quot;gb&quot; =&gt; &quot;United Kingdom&quot;, &quot;de&quot; =&gt; &quot;Germany&quot;, &quot;au&quot; =&gt; &quot;Australia&quot;, &quot;cn&quot; =&gt; &quot;China&quot;, &quot;hk&quot; =&gt; &quot;Hong Kong&quot;, &quot;tw&quot; =&gt; &quot;Taiwan&quot;, &quot;kr&quot; =&gt; &quot;Korea&quot;, &quot;jp&quot; =&gt; &quot;Japan&quot;, &quot;ca&quot; =&gt; &quot;Canada&quot;}, &quot;de&quot; =&gt; {&quot;us&quot; =&gt; &quot;USA&quot;, &quot;eu&quot; =&gt; &quot;Europäische Union&quot;, &quot;fr&quot; =&gt; &quot;Frankreich&quot;, &quot;gb&quot; =&gt; &quot;Großbritannien&quot;, &quot;de&quot; =&gt; &quot;Deutschland&quot;, &quot;au&quot; =&gt; &quot;Australien&quot;, &quot;cn&quot; =&gt; &quot;China (Festland)&quot;, &quot;hk&quot; =&gt; &quot;Hongkong&quot;, &quot;tw&quot; =&gt; &quot;Taiwan&quot;, &quot;kr&quot; =&gt; &quot;Korea&quot;, &quot;jp&quot; =&gt; &quot;Japan&quot;, &quot;ca&quot; =&gt; &quot;Canada&quot;}, &quot;cn&quot; =&gt; {&quot;us&quot; =&gt; &quot;美国&quot;, &quot;eu&quot; =&gt; &quot;欧洲联盟&quot;, &quot;fr&quot; =&gt; &quot;法国&quot;, &quot;gb&quot; =&gt; &quot;联合王国&quot;, &quot;de&quot; =&gt; &quot;德国&quot;, &quot;au&quot; =&gt; &quot;澳大利亚&quot;, &quot;cn&quot; =&gt; &quot;中国&quot;, &quot;hk&quot; =&gt; &quot;香港&quot;, &quot;tw&quot; =&gt; &quot;台湾&quot;, &quot;kr&quot; =&gt; &quot;朝鲜&quot;, &quot;jp&quot; =&gt; &quot;日本&quot;, &quot;ca&quot; =&gt; &quot;加拿大&quot;}, &quot;hk&quot; =&gt; {&quot;us&quot; =&gt; &quot;美国&quot;, &quot;eu&quot; =&gt; &quot;欧洲联盟&quot;, &quot;fr&quot; =&gt; &quot;法国&quot;, &quot;gb&quot; =&gt; &quot;联合王国&quot;, &quot;de&quot; =&gt; &quot;德国&quot;, &quot;au&quot; =&gt; &quot;澳大利亚&quot;, &quot;cn&quot; =&gt; &quot;中國&quot;, &quot;hk&quot; =&gt; &quot;香港&quot;, &quot;tw&quot; =&gt; &quot;台灣&quot;, &quot;kr&quot; =&gt; &quot;韓國&quot;, &quot;jp&quot; =&gt; &quot;日本&quot;, &quot;ca&quot; =&gt; &quot;加拿大&quot;}, &quot;tw&quot; =&gt; {&quot;us&quot; =&gt; &quot;美国&quot;, &quot;eu&quot; =&gt; &quot;欧洲联盟&quot;, &quot;fr&quot; =&gt; &quot;法国&quot;, &quot;gb&quot; =&gt; &quot;联合王国&quot;, &quot;de&quot; =&gt; &quot;德国&quot;, &quot;au&quot; =&gt; &quot;澳大利亚&quot;, &quot;cn&quot; =&gt; &quot;中國&quot;, &quot;hk&quot; =&gt; &quot;香港&quot;, &quot;tw&quot; =&gt; &quot;台灣&quot;, &quot;kr&quot; =&gt; &quot;韓國&quot;, &quot;jp&quot; =&gt; &quot;日本&quot;, &quot;ca&quot; =&gt; &quot;加拿大&quot;}, &quot;kr&quot; =&gt; {&quot;us&quot; =&gt; &quot;미국&quot;, &quot;eu&quot; =&gt; &quot;유럽 ​​연합&quot;, &quot;fr&quot; =&gt; &quot;프랑스&quot;, &quot;gb&quot; =&gt; &quot;연합왕국&quot;, &quot;de&quot; =&gt; &quot;독일&quot;, &quot;au&quot; =&gt; &quot;호주&quot;, &quot;cn&quot; =&gt; &quot;중국&quot;, &quot;hk&quot; =&gt; &quot;홍콩&quot;, &quot;tw&quot; =&gt; &quot;대만&quot;, &quot;kr&quot; =&gt; &quot;우리나라&quot;, &quot;jp&quot; =&gt; &quot;일본&quot;, &quot;ca&quot; =&gt; &quot;캐나다&quot;}, &quot;jp&quot; =&gt; {&quot;us&quot; =&gt; &quot;アメリカ合衆国&quot;, &quot;eu&quot; =&gt; &quot;欧州連合&quot;, &quot;fr&quot; =&gt; &quot;仏蘭西&quot;, &quot;gb&quot; =&gt; &quot;英国&quot;, &quot;de&quot; =&gt; &quot;独逸&quot;, &quot;au&quot; =&gt; &quot;濠太剌利&quot;, &quot;cn&quot; =&gt; &quot;中国&quot;, &quot;hk&quot; =&gt; &quot;香港&quot;, &quot;tw&quot; =&gt; &quot;台湾&quot;, &quot;kr&quot; =&gt; &quot;韓国&quot;, &quot;jp&quot; =&gt; &quot;日本&quot;, &quot;ca&quot; =&gt; &quot;加奈陀&quot;}, &quot;ca&quot; =&gt; {&quot;us&quot; =&gt; &quot;United States&quot;, &quot;eu&quot; =&gt; &quot;European Union&quot;, &quot;fr&quot; =&gt; &quot;France&quot;, &quot;gb&quot; =&gt; &quot;United Kingdom&quot;, &quot;de&quot; =&gt; &quot;Germany&quot;, &quot;au&quot; =&gt; &quot;Australia&quot;, &quot;cn&quot; =&gt; &quot;China&quot;, &quot;hk&quot; =&gt; &quot;Hong Kong&quot;, &quot;tw&quot; =&gt; &quot;Taiwan&quot;, &quot;kr&quot; =&gt; &quot;Korea&quot;, &quot;jp&quot; =&gt; &quot;Japan&quot;, &quot;ca&quot; =&gt; &quot;Canada&quot;}}");
    return countryButtonsObject[ ipCountry ] || countryButtonsObject[ "us" ];
  },
  getCurrentSite: function() {
    var url = window.location.hostname;

    //check for localhost, dev, or qa. Also US site (since it's www, not us.roccat.com)

    if ( /localhost|www.roccat|os-atom|usa/gi.test( url ) ) return "us";
    if ( /roccat-ca/gi.test( url ) ) return "ca";

    //If we are on QA or Stage this will return a result
    var matchSite = /([A-Za-z]{2})+/g.exec(url);
    if (matchSite !== null) {
      if (matchSite[1] === "uk") return "gb";
      return matchSite[1];
    }

    //Return the currentSite based on the prod url
    var index = url.indexOf('.');
    var currentSite = url.slice(0,index);
    //UK subdomain is uk., but the correct designation is GB, so return that instead
    if (currentSite === "uk") return "gb";

    return currentSite;
  },
  getCookie: function() {
    var value = "; " + document.cookie;
    var parts = value.split("; geo-location=");
    if (parts.length == 2) return parts.pop().split(";").shift();
  },
  setCookie: function(value) {
    

    var expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + 7);

    // todo: remove after canada launch
    if (location.hostname.indexOf('roccat-ca') > -1) {
      var domain = "roccat-ca.myshopify.com";
    } else {
      var domain = "." + location.hostname.split('.').reverse()[1] + "." + location.hostname.split('.').reverse()[0];
    }

    //for local testing
    if (location.hostname === "localhost") domain = "localhost";
    document.cookie = "geo-location=" + value + "; expires=" + expirationDate.toDateString() +  "; domain=" + domain + "; path=/";
  }
}

theme.geoip.init();